module.exports = __webpack_public_path__ + "assets/inspection_required.63bcdaba.svg";